import * as Yup from 'yup';

// CONSTANTS
import { MIN_ZIP_CODE_LENGTH, MAX_ZIP_CODE_LENGTH } from '@/constants/validation';

function getEmailSchema(t, isRequired) {
  const schema = Yup.string().email(t('validation.emailNotValid'));

  return isRequired ? schema.required(t('validation.emailRequired')) : schema;
}

function getZipcodeSchema(t, isRequired) {
  const schema = Yup.string()
    .min(MIN_ZIP_CODE_LENGTH, t('validation.minZipCodeLength', { length: MIN_ZIP_CODE_LENGTH }))
    .max(MAX_ZIP_CODE_LENGTH, t('validation.maxZipCodeLength', { length: MAX_ZIP_CODE_LENGTH }));

  return isRequired ? schema.required() : schema;
}

function getPasswordSchema(t, isRequired) {
  const schema = Yup.string()
    .min(10, t('validation.passwordLength', { length: 10 }))
    // At least one uppercase letter
    .matches(/[A-Z]/, t('validation.passwordUppercase'))
    // At least one lowercase letter
    .matches(/[a-z]/, t('validation.passwordLowercase'))
    // At least one number
    .matches(/[0-9]/, t('validation.passwordNumber'))
    // At least one special character but not tilde
    .matches(/[!@#$%^&*()_+=\-\\[\]{};:'",.<>?/]/, t('validation.passwordSpecialChar'))
    // Not allowing tilde character
    .matches(/^[^~]*$/, t('validation.passwordNoTilde'));

  return isRequired ? schema.required(t('validation.passwordRequired')) : schema;
}

function getTermsSchema(t, isRequired) {
  const schema = Yup.boolean();

  return isRequired ? schema.oneOf([true], 'Must agree to register an account') : schema;
}

function fieldRequiredSchema(t, isRequired) {
  const schema = Yup.string();

  return isRequired ? schema.required(t('validation.fieldRequired')) : schema;
}

const validationSchemas = {
  email: getEmailSchema,
  zipcode: getZipcodeSchema,
  password: getPasswordSchema,
  terms: getTermsSchema,
};

export default (t, { fields }) => {
  return fields.reduce((currSchema, { name, type, required }) => {
    const getSchema = validationSchemas[name] || validationSchemas[type] || fieldRequiredSchema;

    if (getSchema) {
      currSchema[name] = getSchema(t, required);
    }

    return currSchema;
  }, {});
};
